import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TextFieldHint, TextFieldHintProps } from '@components/base';

type CasingInputHintProps = Omit<TextFieldHintProps, 'hint'> & {
  casing: 'camel' | 'kebab';
};

export const CasingInputHint: FC<CasingInputHintProps> = ({ casing, position }) => {
  const { t } = useTranslation();

  return (
    <TextFieldHint
      hint={
        <Trans
          components={{ strong: <strong />, code: <code /> }}
          i18nKey={t('case.description', { context: casing })}
        />
      }
      position={position}
    />
  );
};
